import Dialog from '#lib/components/dialog.jsx';
import Input from '#lib/components/input.jsx';
import Button from '#lib/components/button.jsx';
import { addClasses } from '#root/lib/helpers/class.js';
import FloatingTooltip from './tooltip.jsx';
import { useFlightModal } from '#hooks/use-flight-modal.js';

export function FlightModal(props) {
    const { addFlight, startDate, currentDay, isOpen, onClose, profileLanguage, isCreating, ...rest } = props;

    const {
        onCreate,
        loading,
        dateStringFormatted,
        airline,
        setAirline,
        flightNumber,
        setFlightNumber,
        isGetInfoDisabled,
        getInfo
    } = useFlightModal({ addFlight, startDate, currentDay, onClose, profileLanguage, ...rest });

    return (
        <Dialog isOpen={isOpen}>
            <Dialog.Panel static className={`flex flex-col gap-4 min-w-[300px] w-full max-w-[500px]`}>
                {/* HEADER */}
                <div className="pr-8">
                    <Dialog.CloseButton onClick={onClose} />
                    <b>{_t.edit.flightModalTitle(dateStringFormatted)}</b>
                    <p className="pr-2 pt-2 mt-1 text-sm">{_t.edit.flightModalSubTitle()}</p>
                </div>

                {/* BODY */}
                <div className="flex justify-end gap-2 pt-2 items-end">
                    <Input.Full
                        label={_t.edit.fields.airline()}
                        placeholder={_t.edit.fields.airline()}
                        value={airline || ''}
                        name="airline"
                        inputClassName={addClasses(' w-full max-h-[30px] h-[30px]')}
                        onChange={(event) => setAirline(event.target.value)}
                    />
                    <Input.Full
                        label={_t.edit.fields.flightNumber()}
                        placeholder={_t.edit.fields.flightNumber()}
                        value={flightNumber || ''}
                        name="flightNumber"
                        inputClassName={addClasses(' w-full max-h-[30px] h-[30px]')}
                        onChange={(event) => setFlightNumber(event.target.value)}
                    />

                    <Button
                        onClick={getInfo}
                        look={'primary'}
                        size="xs"
                        disabled={isGetInfoDisabled}
                        className={addClasses('flex items-start min-w-[100px] min-h-[32px]')}
                        busy={loading}
                    >
                        {_t.edit.flightModalGetInfo()}
                    </Button>
                </div>

                {/* FOOTER */}
                <div className="flex justify-end gap-2 pt-5">
                    <Button
                        onClick={onClose}
                        look={'white'}
                        size="xs"
                        className={addClasses('flex items-start w-[100px] hover:text-primary-700')}
                    >
                        {_t.danger.cancel()}
                    </Button>
                    {isCreating && (
                        <FloatingTooltip content={_t.edit.flightModalSkipTooltip()} placement="bottom">
                            <Button
                                onClick={() => onCreate()}
                                look={'white'}
                                size="xs"
                                className={addClasses('flex items-start w-[100px]')}
                            >
                                {_t.global.skip()}
                            </Button>
                        </FloatingTooltip>
                    )}
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
